import React from 'react';
import {
    SkeletonCard,
    SkeletonDot,
    SkeletonLine,
    SkeletonContainer,
    SkeletonList,
} from '../styled';
import Wrapper from '../../../ui/Wrapper';
import { SkeletonAnimation } from '../skeletonAnimation';
import { detectMobile } from '../../../utils/UiHelper';

const CombosSkeleton = () => {
    const isMobile = detectMobile();

    const getItems = () => {
        const items = [];
        const b = [1, 2, 3];

        for (let i = 0; i < 8; i++) {
            items.push(
                <SkeletonCard key={i} width="253px">
                    <SkeletonLine
                        height="16px"
                        width="79px"
                        margin="0 0 20px"
                    />
                    {b.map((item, index) => (
                        <Wrapper
                            flex
                            flexAlign="center"
                            justify="flex-start"
                            padding="0"
                            margin={
                                index === b.length - 1 ? '0 0 16px' : '0 0 8px'
                            }
                            key={`${item}_${index}_element`}
                        >
                            <Wrapper display="block" padding="0">
                                <SkeletonDot />
                            </Wrapper>
                            <div>
                                <SkeletonLine height="8px" width="150px" />
                                <SkeletonLine
                                    height="8px"
                                    width="102px"
                                    margin="8px 0 0"
                                />
                            </div>
                        </Wrapper>
                    ))}
                    <SkeletonLine
                        height="40px"
                        width="100%"
                        margin="0"
                        radius={'4px'}
                    />
                </SkeletonCard>
            );
        }

        return items;
    };

    return (
        <SkeletonContainer isMobile={isMobile}>
            <SkeletonList>
                {getItems()}
                <SkeletonAnimation />
            </SkeletonList>
        </SkeletonContainer>
    );
};

export default CombosSkeleton;
